import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import BannerContent from './BannerContent';
import { ManageSeatsLink } from './ManageSeatsLink';
import { useIsUngatedForTeamsOnly } from '../../auth/hooks/useGates';
import { jsx as _jsx } from "react/jsx-runtime";
const renderMessage = (isTeamsOnlyLink, isUngatedForTeamsOnly) => {
  if (isTeamsOnlyLink) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        ManageSeatsLink
      },
      message: "routing-ui.routingRules.teamsOnly.manageSeatsFooter_jsx"
    });
  } else if (isUngatedForTeamsOnly) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        ManageSeatsLink
      },
      message: "routing-ui.routingRules.roundRobin.updatedManageSeatsFooter_jsx"
    });
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      ManageSeatsLink
    },
    message: "routing-ui.routingRules.roundRobin.manageSeatsFooter_jsx"
  });
};
const ManageSeatsBanner = ({
  isTeamsOnlyLink = false,
  onClose
}) => {
  const isUngatedForTeamsOnly = useIsUngatedForTeamsOnly();
  return /*#__PURE__*/_jsx(BannerContent, {
    onClose: onClose,
    children: renderMessage(isTeamsOnlyLink, isUngatedForTeamsOnly)
  });
};
ManageSeatsBanner.displayName = 'ManageSeatsBanner';
export default ManageSeatsBanner;